import React, { useEffect, useMemo, useState } from "react";
import AsyncSelect from "react-select/async";
import api from "../../../services/apiService";
import BotaoSalvar from "../../../components/botao-salvar";
import MensagemErroForm from "../../../components/mensagem-erro-form";
import SeletorCandidatos from "../../../components/seletor-candidatos";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.css";

const FiltroMapaResultadosPorLvPage = () => {
  const [erro, setErro] = useState(null);
  const [loading, setLoading] = useState(false);
  const [siglaEstado, setSiglaEstado] = useState("");
  const [municipioSelecionado, setMunicipioSelecionado] = useState({
    label: "Todos",
    value: null,
  });
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [candidatosSelecionados, setCandidatosSelecionados] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const carregarEstados = async () => {
      try {
        const response = await api.get("/selects/listar-estados-com-resultados");
        setEstados(response.estados || []);
      } catch (error) {
        setErro(error.message || "Erro ao carregar estados.");
      }
    };

    carregarEstados();
  }, []);

  useEffect(() => {
    setMunicipioSelecionado({ label: "Todos", value: null });
    setMunicipios([]);
    setCandidatosSelecionados([]);

    if (!siglaEstado) {
      return;
    }

    const carregarMunicipios = async () => {
      try {
        const response = await api.get("/selects/listar-municipios-com-resultados", {
          params: { sigla_estado: siglaEstado },
        });

        setMunicipios(response.municipios || []);
      } catch (error) {
        setErro(error.message || "Erro ao carregar municípios.");
      }
    };

    carregarMunicipios();
  }, [siglaEstado]);

  const opcoesMunicipios = useMemo(() => {
    const lista = municipios.map((item) => ({
      label: item.nome_municipio,
      value: item.id_municipio,
    }));

    return [{ label: "Todos", value: null }, ...lista];
  }, [municipios]);

  const handleMunicipioChange = (event) => {
    setMunicipioSelecionado(event || { label: "Todos", value: null });
  };

  const buscarMunicipios = async (entrada) => {
    const texto = (entrada || "").toLowerCase().trim();

    if (!texto) {
      return opcoesMunicipios.slice(0, 100);
    }

    return opcoesMunicipios.filter((item) =>
      item.label.toLowerCase().includes(texto)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErro(null);

    if (!siglaEstado) {
      setErro("Selecione um estado");
      setLoading(false);
      return;
    }

    if (candidatosSelecionados.length === 0) {
      setErro("Adicione pelo menos um candidato");
      setLoading(false);
      return;
    }

    if (candidatosSelecionados.length > 3) {
      setErro("Selecione no máximo 3 candidatos");
      setLoading(false);
      return;
    }

    try {
      const filtros = {
        sigla_estado: siglaEstado,
        id_municipio: municipioSelecionado.value,
        ids_candidatos: candidatosSelecionados.map((c) => c.id_candidato),
      };

      const data = await api.post(`/resultados/resultados-por-lv-para-mapa`, filtros);

      navigate("/mapa/resultados-por-lv", {
        state: {
          resultados: data,
          sigla_estado: siglaEstado,
          candidatos: candidatosSelecionados,
        },
      });
    } catch (error) {
      setErro("Erro ao gerar mapa.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="formContainer">
      <h2 className="titulo">Mapa Comparativo</h2>
      {erro && <MensagemErroForm erro={erro} />}

      <form onSubmit={handleSubmit}>
        <fieldset className="fieldset">
          <legend className="titulo">Filtro do Mapa</legend>

          <div className="formRow">
            <div className="formGroup">
              <label>Estado:</label>
              <select
                value={siglaEstado}
                onChange={(e) => setSiglaEstado(e.target.value)}
                required
              >
                <option value="">Selecione o estado</option>
                {estados.map((estado) => (
                  <option
                    key={estado.id_estado || estado.sigla_estado}
                    value={estado.sigla_estado}
                  >
                    {estado.sigla_estado}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="formRow">
            <div className="formGroup">
              <label>Município de Votação:</label>
              <AsyncSelect
                cacheOptions
                defaultOptions={opcoesMunicipios}
                loadOptions={buscarMunicipios}
                value={municipioSelecionado}
                onChange={handleMunicipioChange}
                placeholder="Digite o nome do município"
                className={styles.AsyncSelect}
                classNamePrefix="formSelect"
                isDisabled={!siglaEstado}
              />
            </div>
          </div>

          <div className="formRow">
            <SeletorCandidatos
              siglaEstado={siglaEstado}
              candidatosSelecionados={candidatosSelecionados}
              setCandidatosSelecionados={setCandidatosSelecionados}
              maxCandidatos={3}
              exibirSelecaoCor={true}
            />
          </div>
        </fieldset>

        <div className="actions">
          <BotaoSalvar label="Gerar Mapa" loading={loading} />
        </div>
      </form>
    </div>
  );
};

export default FiltroMapaResultadosPorLvPage;
